import { render } from "./CategoryImg.vue?vue&type=template&id=59f64226&scoped=true&ts=true"
import script from "./CategoryImg.ts?vue&type=script&lang=ts"
export * from "./CategoryImg.ts?vue&type=script&lang=ts"

import "./CategoryImg.vue?vue&type=style&index=0&id=59f64226&scoped=true&lang=scss"

import exportComponent from "D:\\ColorMetalBG\\cmportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f64226"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QImg,QCardActions});qInstall(script, 'directives', {Ripple});
